import commonUtils from "@/utils/common.utils";
import orderSpecsModel from './orderSpecs.model'
import store from "../store/store";
import { getComboSubSelections, validateRepeatComboGroup } from "@/utils/comboSub.utils";

export default class comboSpecs {
    constructor(combo) {
        this.combo = combo;
    }

    // 可重複選：每份一筆 orderCount 1、各自帶規格；其餘依 productSelectCount
    _orderProducts(group) {
        validateRepeatComboGroup(group)
        return getComboSubSelections(group).map(({ product: source, count }) => {
            const product = structuredClone(source)
            delete product.orderProductKey
            return {
                id: commonUtils.generateId(),
                product,
                altAddonPrice: product.altAddonPrice,
                orderCount: count || 1,
                orderSpecs: (product.productSpecSettings || []).map(setting => new orderSpecsModel(setting)),
                vipLevel: store.getters['userData/vipLevel']
            }
        })
    }

    // 固定餐點 沒有包含 subSpecID && comboSubAnyID
    get fixedProducts() {
        return this.combo.fixedProducts.map(product => {
            return {
                id: commonUtils.generateId(),
                product: product,
                // TODO: 根據需求調整 orderCount
                orderCount: 1,
                orderSpecs: product.productSpecSettings.map(setting => new orderSpecsModel(setting)),
                vipLevel: store.getters['userData/vipLevel']
            }
        })
    }

    // 套餐子項 有包含 subSpecID
    get orderComboSubs() {
        let orderComboSubs = []
        let obj = {}
        this.combo.comboSubItem.forEach(group => {
            if (group.subSpecID !== undefined) {
                obj = {...group}
                obj.orderProducts = this._orderProducts(group) || []
                if (obj.productSelectCount) delete obj.productSelectCount;
                if (obj.allProducts) delete obj.allProducts;
                if (obj.products) delete obj.products;
                if (obj.markUpProducts) delete obj.markUpProducts;
                // TODO: 重構 combo 選餐 移除 productSelectCount / allProducts / products / markUpProducts
            }
            obj.vipLevel = store.getters['userData/vipLevel']
            orderComboSubs.push(obj);
        })
        return orderComboSubs;
    }

    
    // 套餐任選子項 有包含 orderProducts
    // 目前任選子項流程有變動，以 orderProducts 為主
    get orderComboSubAny() {
        if (this.combo.comboSubAnyProducts && this.combo.comboSubAnyProducts.orderProducts && this.combo.comboSubAnyProducts.orderProducts.length) {
            const orderComboSubAny = {}
            orderComboSubAny.comboSubAnySetting = {...this.combo.comboSubAnyProducts.comboSubAnySetting} || null
            orderComboSubAny.orderProducts = this.combo.comboSubAnyProducts.orderProducts.map(product => {
                return {
                    id: commonUtils.generateId(),
                    product: { ...product },
                    orderCount: 1,
                    orderSpecs: product.productSpecSettings.map(setting => new orderSpecsModel(setting)),
                    vipLevel: store.getters['userData/vipLevel']
                }
            })
            orderComboSubAny.vipLevel = store.getters['userData/vipLevel']
            return orderComboSubAny
        }
        return null;
    }
}
